import { FormErrorMessage } from '@chakra-ui/react';
import { WarningProps } from '@texas/components/shared/WarningComponent';
import { createArticleStyles as styles } from '@texas/resources/theme/styles/entityWorkspace';

export function ArticleFieldWarning({ warning }: WarningProps) {
  return warning ? (
    <FormErrorMessage sx={styles.fieldWarning}>{warning}</FormErrorMessage>
  ) : null;
}
